<template>
  <div class="root-container-stm">
    <slot name="navbar">
      <navbar
        :logo="logo"
        :is-admin="$allows('administer')"
        :items="navbarItems"
      >
        <template #lang-switcher>
          <language-switcher />
        </template>
        <template #user-info>
          <NavbarMenu v-bind="companyMenu" />
          <NavbarUser />
        </template>
      </navbar>
    </slot>

    <div class="page-content">
      <Sidebar :menu="menuVisible" @on:item:click="onMenuItemClick">
        <template #footer>
          <MobileAppLinks />
        </template>
      </Sidebar>
      <div class="content-wrapper">
        <RouterView />
      </div>
    </div>
  </div>
</template>

<script>
import AdminLayout from '../stylemix-vue-admin/components/layout/layout-main.vue'
import NavbarCurrency from './NavbarCurrency.vue'
import NavbarDivision from './NavbarDivision.vue'
import LanguageSwitcher from '../language-switcher/LanguageSwitcher.vue'
import Sidebar from './Sidebar.vue'
import MobileAppLinks from './MobileAppLinks.vue'
import NavbarMenu from './NavbarMenu.vue'
import NavbarUser from '../stylemix-vue-admin/components/navbar/NavbarUser.vue'
import { RouterView } from 'vue-router'

export default {
  name: 'TheLayout',

  components: {
    LanguageSwitcher,
    MobileAppLinks,
    NavbarMenu,
    NavbarUser,
    RouterView,
    Sidebar,
  },

  extends: AdminLayout,

  data() {
    return {
      companyMenu: {
        title: '',
        items: [],
      },
    }
  },

  computed: {
    menuVisible() {
      if (!this.$account) {
        return []
      }

      return this.menu.filter((item) => {
        if (!item.permission) {
          return false
        }

        if (typeof item.permission === 'function') {
          return item.permission(this)
        }

        return this.$allows(item.permission)
      })
    },

    navbarItems() {
      const navbarItems = []

      if (this.$allows('administer')) {
        navbarItems.push({
          icon: 'icon-map5',
          component: NavbarDivision,
        })
      }

      navbarItems.push({
        icon: 'icon-coin-euro',
        component: NavbarCurrency,
      })

      return navbarItems
    },

    isCompany() {
      return this.$allows('bookings.serve') //&& !this.$allows('administer')
    },
  },

  created() {
    this.loadCompanyMenu()
  },

  methods: {
    loadCompanyMenu() {
      if (!this.isCompany) {
        return
      }
      this.$http.get('settings/company_menu').then(({ data }) => {
        this.companyMenu.title = data.title
        this.companyMenu.items = data.items
      })
    },
  },
}
</script>
